module.exports = __webpack_public_path__ + "img/motorway_4x1_z18.44ad26f1.svg";